import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	shareTriggerButtonText: {
		id: 'share-button.share-trigger-button-text',
		defaultMessage: 'Share',
		description: 'Default text for the disabled share dialog trigger button',
	},
});
